import { Facet } from "@linkfluence/models/facet";
import { useProjectFacets } from "./useProjectFacets";

export function useProjectFacet(facetName: Facet) {
  const facets = useProjectFacets();
  return facets ? facets[facetName] : null;
}
